<template>
  <div id="ProjBidListCard">
    <div class="list-header">
      <div class="list-header-left ellipsis">
        <el-tooltip effect="dark" :content="project.projectName" placement="top">
          <router-link :to="{path:project.projectStatus==1?'/projbid/new/info/'+project.projectId :'/projbid/quotation/summary/'+ project.projectId}">{{project.projectName}}</router-link>
        </el-tooltip>
      </div>
      <div class="list-header-right">
        <template v-if="project.createId==currentUserId">
          <el-badge class="eb-badge" :value="project.replyCount?project.replyCount:''" :max="99">
            <router-link :to="{path:project.projectStatus==1?'/projbid/new/info/'+project.projectId :'/projbid/quotation/summary/'+project.projectId}">
              <el-button class="eb-button-red eb-button-small">
                {{project.projectStatus == 1 ? "编辑项目": "查看报价"}}
              </el-button>
            </router-link>
          </el-badge>
          <router-link v-if="project.projectStatus!=1" :to="{path:'/projbid/preview/'+project.projectId}">
            <el-button class="eb-button-red eb-button-small">查看需求</el-button>
          </router-link>
          <ProjBidBtnDeleteList @onDeleteBidProject="onDeleteBidProject" v-if="project.projectStatus==1" :project="project" class="eb-button-red eb-button-small" />
        </template>
        <template v-else>
          <el-badge class="eb-badge" :value="project.replyCount?project.replyCount:''" :max="99">
            <router-link v-if="project.projectStatus!=1" :to="{path:'/projbid/quotation/summary/'+project.projectId}">
              <el-button class="eb-button-red eb-button-small">查看报价</el-button>
            </router-link>
          </el-badge>
          <router-link :to="{path:'/projbid/preview/'+project.projectId}">
            <el-button class="eb-button-red eb-button-small">查看需求</el-button>
          </router-link>
        </template>
      </div>
    </div>
    <div class="list-body">
      <div class="list-body-left">
        <img v-if="project.projectImages" :src="project.projectImages" alt="项目图片">
        <img v-if="!project.projectImages" :src="$ebConfig.imgPath+'img/project-default.jpg'" alt="项目图片">
      </div>
      <div class="list-body-right">
        <div class="card-three-row">
          <div class="col-210">
            <div class="col-left">项目编号:</div>
            <div class="col-right">
              <el-tooltip :content="project.projectCode" placement="top">
                <span class="col-right-content"> {{project.projectCode}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-242">
            <div class="col-left">当前状态:</div>
            <div class="col-right">
              <span class="col-right-content"> {{project.projectStatus | projBidStatus}}</span>
            </div>
          </div>
          <div class="col-135">
            <eb-font-type>{{project.projectMethod | projectMethod(true)}}</eb-font-type>
            <eb-font-type>{{project.projectType | projectType(true)}}</eb-font-type>
          </div>
          <div class="col-218">
            <eb-share/>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-210">
            <div class="col-left">项目预算:</div>
            <div class="col-right">
              <span class="col-right-content"> {{project.projectBudget | formatCurrency}}</span>
            </div>
          </div>
          <div class="col-242">
            <div class="col-left">采购单位:</div>
            <div class="col-right">
              <el-tooltip :content="project.buyDepartName ||'-'" placement="top">
                <span class="col-right-content"> {{project.buyDepartName||'-'}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-135">
            <div class="col-left">采购经办:</div>
            <div class="col-right">
              <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="project.buyUserheadImg" :src="buyUserheadSrc">
              <img @click="userInfoDialog(project.buyUserId)" class="header_img" v-if="!project.buyUserheadImg" :src="$ebConfig.imgPath+'img/user-default.jpeg'">
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">发布时间:</div>
            <div class="col-right">
              <el-tooltip :content="project.startTime | dateFormatYMDH " placement="top">
                <span class="col-right-content"> {{project.startTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-210">
            <div class="col-left">中标价格:</div>
            <div class="col-right">
              <el-tooltip :content="project.supplierPrice | formatCurrency" placement="top">
                <span class="col-right-content"> {{project.supplierPrice | formatCurrency}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-242 componyInfoCol">
            <div class="col-left">中选单位:</div>
            <div class="col-right">
              <el-tooltip :content="project.supplierDepartName ||'-'" placement="top">
                <span @click="conpanyInfo" class="col-right-content conpanyInfo"> {{project.supplierDepartName||'-'}}</span>
              </el-tooltip>
              <eb-font-type v-show="project.supplierAuthStatus=='1'" class="font-type conpanyInfoFont">实</eb-font-type>
            </div>
          </div>
          <div class="col-135">
            <div class="col-left">供方代表:</div>
            <div class="col-right">
              <img @click="userInfoDialog(project.supplierUserId)" class="header_img" v-if="project.supplierUserheadImg" :src="supplierUserheadImgSrc">
              <img @click="userInfoDialog(project.supplierUserId)" class="header_img" v-if="(!project.supplierUserheadImg)&&project.supplierUserId" :src="$ebConfig.imgPath+'img/user-default.jpeg'">
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">截标时间:</div>
            <div class="col-right">
              <el-tooltip :content="project.endTime | dateFormatYMDH " placement="top">
                <span class="col-right-content"> {{project.endTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ebFontType from '@/components/common/eb-font-type';
import ebShare from '@/components/common/share/eb-share';
import ProjBidBtnDeleteList from '@/components/project/bid/list/ProjBidBtnDeleteList';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios';
// import { isMySupplier } from '@/services/user/user-supplier-service';
export default {
  name: 'ProjBidListCard',
  props: ['project'],
  components: {
    ebFontType,
    ebShare,
    ProjBidBtnDeleteList
  },
  data() {
    return {
      currentUserId: this.$store.state.user.userInfo.userid
    };
  },
  computed: {
    buyUserheadSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.buyUserheadImg + '?time=' + Date.now();
      }
    },
    supplierUserheadImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.supplierUserheadImg + '?time=' + Date.now();
      }
    }
  },
  methods: {
    onDeleteBidProject: function() {
      this.$emit('onDeleteBidProject');
    },
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    async conpanyInfo() {
      // let supplierDepartId = this.project.supplierDepartId;
      // if (!supplierDepartId) {
      //   return false;
      // }
      // try {
      //   let { data } = await isMySupplier(this.project.buyUserId, this.project.supplierUserId);
      //   if (data.returnCode === '01') {
      //     sessionStorage.setItem('bId', data.buyerId);
      //     sessionStorage.setItem('departIdSu', data.supplierId);
      //     sessionStorage.setItem('suType', data.isSupplier);
      //     sessionStorage.setItem('userSupilierId', data.userSupplierId);
      window.open('/supplier/detail/' + this.project.supplierOrgId);
      //   } else {
      //     this.$message.error('获取供应商信息失败');
      //   }
      // } catch (error) {
      //   this.$message.error('获取供应商信息失败');
      // }
    }
  }
};
</script>
<style  lang="less">
#ProjBidListCard {
  .list-header {
    display: flex;
    flex-wrap: wrap;
  }
  .list-header-left {
    height: 52px;
    width: 60%;
    line-height: 52px;
    a {
      color: #060606;
      font-weight: 700;
      font-family: 'Microsoft YaHei';
    }
  }
  .list-header-right {
    padding-top: 13px;
    width: 39%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .list-body {
    display: flex;
    flex-wrap: wrap;
  }
  .list-body-left {
    height: 135px;
    width: 18.3%;
    display: flex;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .list-body-right {
    width: 80.6%;
    padding-left: 1%;
  }
  .eb-button-red {
    margin-left: 10px;
  }
  .header_img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-top: 8px;
    cursor: pointer;
  }
  .font-type {
    margin-right: 11px;
  }
  .componyInfoCol {
    position: relative;
  }
  .conpanyInfo {
    cursor: pointer;
    max-width: 80%;
  }
  .conpanyInfoFont {
    position: absolute;
    right: 0;
    top: 10px;
    line-height: 21px;
  }
  .eb-badge .el-badge__content {
    right: 17px;
  }
}
</style>
